/* @flow */
import { createSelector } from 'reselect'

import { getRoot } from '../rootSelector'
import type { Action, BlacklistStore, BlacklistUrl } from '../../types'
import { ActionRequiresPropertyError } from '../../helpers'

export const CLEAR_BLACKLIST_STORE: string = 'opinary/CLEAR_BLACKLIST_STORE'
export const FETCH_BLACKLIST: string = 'opinary/FETCH_BLACKLIST'
export const INTO_BLACKLIST_STORE: string = 'opinary/INTO_BLACKLIST_STORE'
export const ADD_URL_BLACKLIST_STORE: string = 'opinary/ADD_URL_BLACKLIST_STORE'
export const DELETE_URL_BLACKLIST_STORE: string =
  'opinary/DELETE_URL_BLACKLIST_STORE'

// Actions
export function clearBlacklistStore(): Action {
  return {
    type: CLEAR_BLACKLIST_STORE,
  }
}

export function fetchBlacklist(): Action {
  return {
    type: FETCH_BLACKLIST,
  }
}

export function intoBlacklistStore(item: BlacklistStore): Action {
  return {
    type: INTO_BLACKLIST_STORE,
    item,
  }
}

export function addUrlBlacklistStore(item: BlacklistUrl): Action {
  return {
    type: ADD_URL_BLACKLIST_STORE,
    item,
  }
}

export function deleteUrlBlacklistStore(id: number): Action {
  return {
    type: DELETE_URL_BLACKLIST_STORE,
    id,
  }
}

// Selectors
export const selectBlacklist = createSelector(
  getRoot,
  ({ automationStore }) => automationStore.blacklistStore
)

// Reducer
const defaultState = {
  count: 0,
  next: '',
  previous: '',
  results: null,
}

export default function reducer(
  state: BlacklistStore = defaultState,
  action: Action
): BlacklistStore {
  switch (action.type) {
    case INTO_BLACKLIST_STORE:
      if (!action.item) {
        throw new ActionRequiresPropertyError(ADD_URL_BLACKLIST_STORE, 'item')
      } else {
        return action.item
      }
    case ADD_URL_BLACKLIST_STORE:
      if (!action.item) {
        throw new ActionRequiresPropertyError(INTO_BLACKLIST_STORE, 'item')
      } else {
        if (!state.results) {
          return {
            ...state,
            results: [action.item],
          }
        }
        return {
          ...state,
          results: [...state.results, action.item],
        }
      }
    case DELETE_URL_BLACKLIST_STORE:
      if (!action.id) {
        throw new ActionRequiresPropertyError(
          DELETE_URL_BLACKLIST_STORE,
          'item'
        )
      } else {
        if (!state.results) {
          return state
        }
        const index = state.results.findIndex(item => item.id === action.id)
        if (index > -1) {
          return {
            ...state,
            results: [
              // $FlowFixMe - Flow throws error on potentially null state.results even though it returns above
              ...state.results.slice(0, index),
              // $FlowFixMe
              ...state.results.slice(index + 1),
            ],
          }
        } else {
          return state
        }
      }
    case CLEAR_BLACKLIST_STORE:
      return defaultState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/automation/blacklistStore.js